<template>
  <div class="titbox">
    <div style="display: flex; align-items: center;margin:10px 0px;">
      <el-autocomplete
        v-model="officialAccount"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入公众号"
        @select="handleSelect"
      />
    </div>

    <div class="line" />
    <div class="keyindicators">
      <div class="ketitembox">
        <div
          style="margin-right: 15px;display: flex;flex-direction: column;"
        >
          <span class="addtext">昨日新增人数</span>
          <span class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.totalNew : '请选择公众号' }}</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <span class="addtext">今日新增人数</span>
          <span class="addnum">{{ keyindicators.today ? keyindicators.today.totalNew : '请选择公众号' }}</span>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <span class="addtext">昨日取关注人数</span>
          <span class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.totalCancel : '请选择公众号' }}</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <span class="addtext">今日取关注人数</span>
          <span class="addnum">{{ keyindicators.today ? keyindicators.today.totalCancel : '请选择公众号' }}</span>
        </div>
      </div>
      <div class="ketitembox">
        <div style="margin-right: 15px;display: flex;flex-direction: column;">
          <div class="addtext">昨日净增</div>
          <div class="addnum">{{ keyindicators.yesterday ? keyindicators.yesterday.netGrowth : '请选择公众号' }}</div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">今日净增</div>
          <div class="addnum">{{ keyindicators.today ? keyindicators.today.netGrowth : '请选择公众号' }}</div>
        </div>
      </div>
      <div class="ketitembox">
        <div style="display: flex;flex-direction: column;">
          <div class="addtext">累计关注</div>
          <div class="addnum">{{ keyindicators.totalAll !== undefined ? keyindicators.totalAll : '请选择公众号' }}</div>
        </div>
      </div>
    </div>
    <div class="line-linr" />
    <div class="selectbtn">
      <!-- <el-button :plain="money !== 1" type="primary" :icon="money === 1 ? 'el-icon-success' : ''" @click="selectgo(1)">新增人数</el-button>
      <el-button :plain="money !== 2" type="primary" :icon="money === 2 ? 'el-icon-success' : ''" @click="selectgo(2)">取消关注人数</el-button>
      <el-button :plain="money !== 3" type="primary" :icon="money === 3 ? 'el-icon-success' : ''" @click="selectgo(3)">净增关注人数</el-button> -->
      <el-date-picker
        v-model="times"
        style="margin-left:10px;"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :default-value="new Date().setMonth(new Date().getMonth() - 1)"
      />
      <!-- :default-value="new Date().setMonth(new Date().getMonth() - 1)" -->
      <el-select v-model="officialType" placeholder="请选择类型" style="margin-left:10px;">
        <el-option
          v-for="item in keyindicators.source ? Object.keys(keyindicators.source).map((item)=>{
            return {
              id: item,
              value: keyindicators.source[item]
            }
          }) : []"
          :key="item.id"
          :label="item.value"
          :value="item.id"
        />
      </el-select>
      <el-button type="success" style="margin-left:20px;" @click="query">查询</el-button>
    </div>
    <div id="main3" class="echarts" style="width:80vw; " />
    <el-table
      :data="tableData.slice((pase-1)*10, pase*10)"
      border
      style="width: 100%;margin-top:10px"
    >
      <el-table-column
        prop="time"
        label="时间"
        width="180"
      />
      <el-table-column
        v-if="!money.includes('新增关注')"
        prop="new"
        label="新增关注"
        width="180"
      />
      <el-table-column
        v-if="!money.includes('取关')"
        prop="cancel"
        label="取关"
      />
      <el-table-column
        v-if="!money.includes('净增')"
        prop="netGrowth"
        label="净增"
      />
    </el-table>
    <PaginationRight
      :total="tableData.length"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <!-- <div id="app">
      <div v-for="(item,index) in list" :key="index" class="updataboxr">
        <img style="width:200px;height:120px" :src="item">
        <div class="delect" @click="delect(index)">×</div>
      </div>
      <div class="uploadSec">
        <img style="width:200px;height:120px" src="https://qie-online-sale-qiniu.wsandos.com/2021/02601a0ee2a9c52.png" alt="上传图标">
        <input id="choose" type="file" value="" multiple @change="upload">
      </div>

    </div> -->
    <!-- <el-upload
      :action="domain"
      :data="QiniuData"
      :on-remove="handleRemove"
      :on-error="uploadError"
      :on-success="uploadSuccess"
      :before-remove="beforeRemove"
      :before-upload="beforeAvatarUpload"
      :limit="3"
      multiple
      :on-exceed="handleExceed"
      :file-list="fileList"
      list-type="picture-card"
    >

      <i size="small" type="primary">+</i>
      <i style="display:inline-block">请选择封面</i>

    </el-upload> -->

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->
    <!-- <div>
      <img v-if="uploadPicUrl" class="pic-box" :src="uploadPicUrl">
    </div> -->
    <!-- <div v-for="(item, index) in fileListimg" :key="index">
      <img v-if="fileListimg" class="pic-box" :src="`${qiniuaddr}${item.response.key}`">
    </div> -->
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { qiniuToken } from '@/api/qiniuToken.js'
import { fanStatistics, officialAccountSearchDisplay, fanIconStatistics } from '@/api/effectData.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 把选择的第一个日期赋值给一个变量。
          this.choiceDate = minDate.getTime()
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) this.choiceDate = ''
        },
        disabledDate: (time) => {
          // 如何选择了一个日期
          if (this.choiceDate) {
            // 7天的时间戳
            const one = 6 * 24 * 3600 * 1000
            // 当前日期 - one = 7天之前
            const minTime = this.choiceDate - one
            // 当前日期 + one = 7天之后
            const maxTime = this.choiceDate + one
            return (
              time.getTime() < minTime ||
              time.getTime() > maxTime ||
              // 限制不能选择今天及以后
               time.getTime() + 1 * 24 * 3600 * 1000 > Date.now()
            )
          } else {
            // 如果没有选择日期，就要限制不能选择今天及以后
            return time.getTime() + 1 * 24 * 3600 * 1000 > Date.now()
          }
        }
      },

      money: [],
      myChart: '',
      value1: '',
      tableData: [],
      series: [],
      list: [],
      QiniuData: {
        key: '', // 图片名字处理
        token: '' // 七牛云token
      },
      domain: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
      qiniuaddr: 'http://ziyuan.jingxuansz.com/', // 七牛云的图片外链地址
      uploadPicUrl: '', // 提交到后台图片地址
      fileList: [],
      fileListimg: [],
      disabled: false,
      officialAccount: this.$route.query.appId, // 公众号
      keyindicators: {}, // 存储根据公众号获取的数据
      officialType: '', // 选择公众号枚举值
      times: [], // 时间
      pase: 1, // 当前页
      allappid: null
    }
  },
  async created() {
    this.getQiniuToken()
    const data = await officialAccountSearchDisplay({
      appId: this.$route.query.appId
    })
    // data.data.list = data.data.list
    this.officialAccount = data.data.list[0].account_name
    // this.officialAccount = data.data.list.filter(item => item.appId === this.$route.query.appId)[0].accountName
  },
  mounted() {
    this.localEchart()
    this.chartResize(this.myChart)
    this.myChart.on('legendselectchanged', (params) => {
      if (params.selected[params.name]) { // 去除
        this.money = this.money.filter(item => item !== params.name)
      } else if (!params.selected[params.name]) { // 添加
        this.money.push(params.name)
      }
    })
    this.handleSelect({ app_id: this.officialAccount })
  },
  methods: {
    // 获取七牛token
    getQiniuToken() {
      qiniuToken().then(res => {
        this.QiniuData.token = res.data.upToken
      })
    },
    localEchart(legend = [], tiems = []) {
      const chartDom = document.getElementById('main3')
      this.myChart = echarts.init(chartDom)
      var option
      option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: tiems
        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      }
      option && this.myChart.setOption(option, true)
    },
    chartResize(chart) {
      window.addEventListener('resize', () => {
        chart.resize()
      })
    },
    upload(e) {
      // e.target指向事件执行时鼠标所点击区域的那个元素，那么为input的标签，
      // 可以输出 e.target.files 看看，这个files对象保存着选中的所有的图片的信息。
      console.log(e.target.files)
      // ------------------------------------------------------
      // 既然如此，循环这个files对象，用for of 循环，
      for (const item of e.target.files) {
        // 正则表达式，判断每个元素的type属性是否为图片形式，如图
        if (!/image\/\w+/.test(item.type)) {
          // 提示只能是图片，return
          alert('只能选择图片')
          return
        }// 保存下当前 this ，就是vue实例
        var _this = this
        //  创建一个FileReader()对象，它里面有个readAsDataURL方法
        const reader = new FileReader()
        // readAsDataURL方法可以将上传的图片格式转为base64,然后在存入到图片路径,
        // 这样就可以上传电脑任意位置的图片
        reader.readAsDataURL(item)
        // 文件读取成功完成时触发
        reader.addEventListener('load', function() {
          console.log(this.result)
          //  reader.result返回文件的内容。
          // 只有在读取操作完成后，此属性才有效，返回的数据的格式取决于是使用哪种读取方法来执行读取操作的。
          // 给数组添加这个文件也就是图片的内容
          _this.list.push(this.result)
        })
      }
      // ------------------------------------------------------------
    },
    delect(index) {
      console.log(index)
      this.list.splice(index, 1)
    },
    noDelect() {
      alert('默认图片无法删除。')
    },
    dragover(e) {
      e.preventDefault()
    },
    drag(e) {
      // const fileIfon = e.dataTransfer.files[0]
      // console.log('e', fileIfon)
      e.preventDefault()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 张图片，如需更换，请删除上一张图片在重新选择！`
      )
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.QiniuData.key = `upload_pic_${file.name}`
    },
    uploadSuccess(response, file, fileList) {
      console.log(fileList, response)
      // this.fileList = fileList
      // this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`
    },
    uploadError(err, file, fileList) {
      console.log(err)
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    async querySearchAsync(queryString, cb) {
      const data = await officialAccountSearchDisplay({ accountName: queryString })
      const list = data.data.list
      list.forEach((item) => {
        item.value = item.account_name
        item.address = item.app_id
      })
      cb(list)
    },
    async handleSelect(item) {
      const data = await fanStatistics({ appId: item.app_id })
      this.keyindicators = data.data
      this.allappid = item.app_id
      this.empty()
      this.query()
      // this.localEchart()
    },
    async query() {
      const data = {
        appId: this.allappid,
        beginTime: this.times ? this.times[0].toLocaleDateString().split('/').join('-') : null,
        endTime: this.times ? this.times[1].toLocaleDateString().split('/').join('-') : null,
        source: this.officialType ? this.officialType : undefined
      }
      if (this.verification(data)) {
        const data1 = await fanIconStatistics(data)
        const arr = this.conversionSplicing(data1.data)
        this.series = arr
        this.tableData = data1.data
        this.localEchart(this.series.map(item => item.name), data1.data.map(item => item.time))
      }
    },

    // 数据校验
    verification(data) {
      if (!data.appId || !data.beginTime || !data.endTime) {
        this.$message({
          message: data.appId ? '请选择日期' : '请选择公众号',
          type: 'warning'
        })
        return false
      }
      return true
    },
    // 将数据进行转换成图标所需的数据
    conversionSplicing(data) {
      const obj = {
        new: [],
        netGrowth: [],
        cancel: []
      }
      const arr = []
      data.forEach((item) => {
        typeof (item.cancel) === 'number' && obj.cancel.push(item.cancel)
        typeof (item.netGrowth) === 'number' && obj.netGrowth.push(item.netGrowth)
        typeof (item.new) === 'number' && obj.new.push(item.new)
      })
      const names = { time: '时间', new: '新增关注', cancel: '取关', netGrowth: '净增' }
      for (const key in obj) {
        if (obj[key].length) {
          arr.push({
            name: names[key],
            type: 'line',
            stack: 'Total',
            data: obj[key]
          })
        }
      }

      return arr
    },

    fetchPageSize(value) {
      console.log(value)
    },

    fetchCurrentPage(value) {
      this.pase = value
    },

    // 重置数据
    empty() {
      this.officialType = ''
      // this.times = []
      this.times = [new Date(new Date().getTime() - 72 * 60 * 60 * 1000), new Date(new Date().getTime() - 24 * 60 * 60 * 1000)]
      this.series = []
      this.money = []
      this.pase = 1
      this.tableData = []
    }
  }
}
</script>
<style scoped>
.titbox{
/*   padding: 20px 20px 0px 20px; */
}
.title{
  color: aqua;
  font-size: 20px;
  margin-bottom: 10px;
}
.line{
  width: 100%;
  height: 1px;
  background: #ccc;
}
.keyindicators{
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  box-sizing: border-box;
}
.ketitembox{
  text-align: center;
  position: relative;
  display: flex;
  width: 25%;
  justify-content: center;
}
.ketitembox::after{
  content: '';
  height: 40px;
  width: 2px;
  background: rgb(35, 139, 224);
  position: absolute;
  right: 0px;
  top: 10px;
}
.ketitembox:last-child::after{
  content: '';
  height: 0px;
  width: 0px;
}
.addtext{
  color: black;
  /* font-weight: bold; */
  font-size: 13px;
}
.addnum{
  color: red;
  font-size: 12px;
  margin-top: 15px;
}
.line-linr{
  height: 20px;
  width: 100%;
  background: #ccc;
  margin-top: 20px;
}
.selectbtn{
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
}
.select_btnr{
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-right: 5px;
  color: aquamarine;
}
.active{
  background: pink;
  color: white;
}
.echarts {
  width: 90vw;
  height: 400px;
}
.choosedata{
  display: flex;
  align-items: center;
      }
      .seleadatra{
        margin-right: 10px;
      }

      #app{
            width: 900px;
            background-color: rgb(241, 241, 241);
            margin: 50px auto;
            display: flex;
        }

        .delect{
            position: absolute;
            right: 0;
            top: 0;
             width: 20px;
             height: 20px;
             text-align: center;
             line-height: 20px;
             font-size: 15px;
             background-color: rgba(255, 255, 255,0.5);
             user-select: none;
             cursor: pointer;
             /* opacity: 0; */
        }

        .upload{
            width: 80px;
            height: 20px;
            background-color: rgba(135, 206, 235,0.2);
            border: 1px dashed black;
            border-radius: 5px;
            position: relative;

        }
        .upload:hover{
            background-color: rgba(135, 206, 235,1);
        }
        .upload::before{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            content: '上传图片';
            font-size: 13px;
            text-align: center;
            font-family: 'fangsong';
            line-height: 20px;
            user-select: none;
        }
        #file{
            width: 100%;
            height: 100%;
            opacity: 0;
        }

             .uploadSec{
          position: relative;
          display: inline-block;
          overflow: hidden;
             }
          #choose{
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            opacity: 0;
          }
.updataboxr{
  position: relative;
}
</style>

